/**
 * Token List Configuration
 * Centralized configuration for token list URLs to avoid hardcoded values
 */

// Get token list URL from environment variable
export const getTokenListUrl = (): string => {
  const envUrl = process.env.NEXT_PUBLIC_TOKEN_LIST_URL
  
  if (!envUrl) {
    throw new Error(
      'NEXT_PUBLIC_TOKEN_LIST_URL environment variable is required. ' +
      'Please set it in your .env file.'
    )
  }
  
  return envUrl
}

// Environment detection for development vs production
export const isDevelopmentEnvironment = (): boolean => {
  if (typeof window === 'undefined') {
    // Server-side: check NODE_ENV
    return process.env.NODE_ENV === 'development'
  }
  // Client-side: check hostname
  return window.location.hostname === 'localhost' || 
         window.location.hostname === '127.0.0.1' ||
         window.location.hostname.includes('localhost')
}

// Get the appropriate URL based on environment
export const getEffectiveTokenListUrl = (): string => {
  // Always use API proxy in development to avoid CORS issues
  if (isDevelopmentEnvironment()) {
    // Only log on client-side to avoid build-time noise
    if (typeof window !== 'undefined') {
      console.log('Development mode detected, using API proxy for token list')
    }
    return '/api/tokenlist'
  }
  
  // In production: use direct GitHub URL from environment variable
  // This avoids the proxy overhead and connection issues
  // Direct fetch benefits from browser's built-in connection pooling
  const directUrl = getTokenListUrl()
  // Only log on client-side to avoid build-time noise
  if (typeof window !== 'undefined') {
    console.log('Production mode: using direct token list URL for better performance and reliability')
  }
  return directUrl
}
